import * as _ from "lodash";
import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { DialogUtils } from "../../helper/dialog.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";

let EffortFormComponent = {
    selector: "vcEffortForm",
    templateUrl: "/angular/components/effort/effort-form.component.html",
    bindings: {
        effort: "=",
        __env: "=?",
    },
    controller: class EffortController {
        // * bindings for typescript compiler *
        public effort: any;
        public __env?: any;
        // ************************************

        public readonly icons = [
            "directions_walk",
            "people",
            "call",
            "insert_emoticon",
            "list",
            "monetization_on",
            "question_answer",
            "check_box_outline_blank",
            "keyboard",
            "chat",
            "mail",
            "reply",
            "campaign",
            "assignment",
            "build",
            "date_range",
            "traffic",
            "event",
            "favorite",
            "face",
            "history",
            "home",
            "flag",
            "hearing",
            "keyboard_voice",
            "import_contacts",
            "content_cut",
            "weekend",
            "access_alarm",
            "local_airport",
            "local_bar",
            "local_cafe",
            "restaurant",
            "person_pin",
            "directions_bike",
            "subway",
            "wc",
            "all_inclusive",
            "golf_course",
            "whatshot",
            "thumb_up",
        ];
        public readonly effortDescription =
            "A new effort should be created when you wish to interact with the contacts in your database on a separate topic or campaign. \
                                            On the left are some examples of useful efforts for you, if you don't see one you like, don't worry, click to create from a \
                                            blank template.";
        public effortTypes: object[];
        public allowMultiple = false;
        public selectedType: any = "";
        public editIcon = false;

        private $scope: any;
        private dialog: DialogUtils;

        private dataProvider: EffortDataProvider;
        public navigationBarService: NavigationBarHelperService;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            EffortDataProvider: EffortDataProvider,
            NavigationBarHelperService: NavigationBarHelperService
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;

            this.dataProvider = EffortDataProvider;
            this.navigationBarService = NavigationBarHelperService;

            this.$scope.$watch(
                () => this.selectedType,
                (newValue: any, oldValue: any) => {
                    if (oldValue != newValue) {
                        this.effort = angular.copy(this.selectedType);
                    }
                },
                true
            );
        }

        $onInit() {
            this.effortTypes = _.cloneDeep(this.dataProvider.types);
        }

        setEditIcon(newValue: boolean): void {
            this.editIcon = newValue;
        }

        selectType(type: any): void {
            if (!this.allowMultiple) {
                angular.forEach(this.effortTypes, (effortType: any) => {
                    effortType.selected = false;
                });
            }
            type.selected = true;
        }

        blankTemplate(): void {
            this.effort.icon = "directions_walk";
        }

        submit(): void {
            if (!this.effort.id) {
                this.dataProvider
                    .createEffort(this.effort)
                    .then((effort: Effort) => {
                        this.dialog.hide(effort);
                    });
            } else {
                this.dataProvider
                    .updateEffort(this.effort)
                    .then((effort: Effort) => {
                        this.dialog.hide(effort);
                    });
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("effort")
    .component(EffortFormComponent.selector, EffortFormComponent);
